import { render, staticRenderFns } from "./home-ws.vue?vue&type=template&id=1f50c1ad&"
import script from "./home-ws.vue?vue&type=script&lang=js&"
export * from "./home-ws.vue?vue&type=script&lang=js&"
import style0 from "./home-ws.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports